module.exports = __webpack_public_path__ + "static/apple-icon-180x180-622bef8ad4ac08dfbe4ca28e4aa7cdbd.png";